import { render, staticRenderFns } from "./university-rank.vue?vue&type=template&id=28d172b8&scoped=true&"
import script from "./university-rank.vue?vue&type=script&lang=js&"
export * from "./university-rank.vue?vue&type=script&lang=js&"
import style0 from "./university-rank.vue?vue&type=style&index=0&id=28d172b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d172b8",
  null
  
)

export default component.exports